module.exports = __webpack_public_path__ + "img/point.f7946c91.png";